<section class="prod-section">
  <div class="common-container">
    <div class="prod-header">
      <h1 class="prod-title">Nuestros servicios</h1>
      <p class="prod-subtitle">
        Software a medida, alojamiento, dominios y más
      </p>
    </div>

    @if (isLoading) {
      <div class="prod-loading">
        <p>Cargando servicios...</p>
      </div>
    } @else if (items.length === 0) {
      <div class="prod-empty">
        <p>Próximamente</p>
      </div>
    } @else {
      <!-- Agrupar por categoría si existe -->
      <div class="prod-grid">
        @for (item of items; track item.cms_item_id) {
          <div class="prod-card">
            @if (item.heroImage) {
              <div class="prod-card__img-wrap">
                <img
                  [src]="item.heroImage"
                  [alt]="item.title"
                  class="prod-card__img"
                  loading="lazy" />
              </div>
            }

            <div class="prod-card__body">
              @if (item.category) {
                <span class="prod-card__category">{{ item.category }}</span>
              }

              <h2 class="prod-card__title">{{ item.title }}</h2>

              @if (item.subtitle) {
                <p class="prod-card__subtitle">{{ item.subtitle }}</p>
              }

              @if (item.description) {
                <div
                  class="prod-card__desc"
                  [innerHTML]="item.description"></div>
              }

              <div class="prod-card__footer">
                @if (item.price) {
                  <div class="prod-card__price">
                    <span class="prod-card__price-value"
                      >{{ item.price }} €</span
                    >
                    @if (item.priceUnit) {
                      <span class="prod-card__price-unit">{{
                        item.priceUnit
                      }}</span>
                    }
                  </div>
                } @else {
                  <div class="prod-card__price">
                    <span class="prod-card__price-unit"
                      >Precio a consultar</span
                    >
                  </div>
                }

                <button
                  class="prod-card__btn"
                  type="button"
                  (click)="pay(item)">
                  Contratar
                </button>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</section>
